import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookups = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/oas/tolerance/lookups`, { params: filters });
	return data;
};

export const getTolerances = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/oas/tolerance/`, { params: filters });
	return data;
};

export const getToleranceById = async (id) => {
	const { data } = await axios.get(`${API}/app/maintainer/oas/tolerance/${id}`);
	return data;
};

export const saveTolerances = async (params) => {
	const { data } = await axios.post(`${API}/app/maintainer/oas/tolerance/`, params);
	return data;
};
